import {
  Box,
  Grid,
  Menu,
  MenuItem,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { SortResultsMenu } from "../../components/SortResultsMenu";
import { hideFilters } from "../../features";
import { useContext, useState } from "react";
import { AppContext } from "../../contextProviders/AppContext";
import { TbAdjustmentsHorizontal } from "react-icons/tb";
import { translation } from "../../components/Dictionary";
import { ExpandMore } from "@mui/icons-material";
import { ADDITIONAL_FIELDS_ALL } from "../../shared/additional-fields";
import { getFixedLanguageSet } from "../../utilities";

export function FilterOffers({
  fetchOffersLoading,
  offers,
  sortBy,
  setSortBy,
  sortOptions,
  setSelectedFilter,
}) {
  const [showFilters, setShowFilters] = useState(false);

  if (offers === "no offers" || offers?.length === 0) {
    return null;
  }
  return (
    <>
      <Box
        sx={{
          marginTop: "25px",
          marginBottom: "10px",
        }}
      >
        {!fetchOffersLoading && offers.length > 0 && (
          <Stack
            direction={"row"}
            justifyContent="space-evenly"
            alignItems="center"
          >
            <Box>
              <SortResultsMenu
                sortBy={sortBy}
                setSortBy={setSortBy}
                sortOptions={sortOptions}
              />
            </Box>
            <ShowFiltersButton
              setShowFilters={setShowFilters}
              showFilters={showFilters}
            />
          </Stack>
        )}
        <FiltersByOfferAttributes
          setShowFilters={setShowFilters}
          showFilters={showFilters}
          setSelectedFilter={setSelectedFilter}
          offers={offers}
        />
      </Box>
    </>
  );
}

function ShowFiltersButton({ showFilters, setShowFilters }) {
  const { selectedCompany, language } = useContext(AppContext);
  const FEATURE_HIDE_FILTERS = selectedCompany?.group
    ? hideFilters(selectedCompany?.group)
    : false;

  const theme = useTheme();
  if (FEATURE_HIDE_FILTERS) {
    return null;
  }
  return (
    <Box
      sx={{
        height: "44px",
        margin: "5px",
        backgroundColor: "transparent",
        fontSize: "14px",
        display: "flex",
        flexDirection: "row",
        /*       alignItems: "center",
justifyContent: "center", */
        borderRadius: "45px",
        border: "1px solid lightgrey",
        overflow: "hidden",
        transition: "250ms ease-in-out",
        "&:hover": {
          bgcolor: "rgba(0,0,0,0.02)",
          boxShadow: theme.shadows[3],
        },
        cursor: "pointer",
      }}
      onClick={() => setShowFilters((prevState) => !prevState)}
    >
      <Box
        sx={{
          height: "44px",
          //    bgcolor: theme.palette.primary.main,
          transition: "250ms ease-in-out",
          color: theme.palette.primary.main,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "24px",
          paddingLeft: "10px",
          paddingRight: "10px",
          bgcolor: theme.palette.secondary.background,
        }}
      >
        <TbAdjustmentsHorizontal />
      </Box>
      <Box
        sx={{
          height: "44px",
          display: "flex",
          alignItems: "center",
          paddingRight: "15px",
          bgcolor: theme.palette.secondary.background,
        }}
      >
        <Typography
          variant="body1"
          sx={{ color: theme.palette.primary.mainText }}
        >
          {showFilters
            ? translation.get(language, "Hide text")
            : translation.get(language, "Show text")}{" "}
          {translation.get(language, "Filters text")}
        </Typography>
      </Box>
    </Box>
  );
}

function FiltersByOfferAttributes({ showFilters, setSelectedFilter, offers }) {
  const { language, mobileViewPort } = useContext(AppContext);

  const createFilters = (offers) =>
    offers.reduce((acc, offer) => {
      const offerAttributes = offer?.vehicle?.additionalFields;
      offerAttributes?.forEach((attribute) => {
        if (attribute.key === "other" || attribute.key === "equipments") {
          return null;
        }

        if (acc[attribute.key]) {
          const attributeValue =
            attribute.valueT?.[getFixedLanguageSet(language)] ??
            attribute.value;
          if (attributeValue && !acc[attribute.key].includes(attributeValue)) {
            acc[attribute.key].push(attributeValue);
          }
        } else {
          const attributeValue =
            attribute.valueT?.[getFixedLanguageSet(language)] ??
            attribute.value;
          if (!!attributeValue) acc[attribute.key] = [attributeValue];
        }
      });
      return acc;
    }, {});

  const filters = createFilters(offers);

  if (!showFilters) {
    return null;
  }

  return (
    <Grid
      container
      direction={"row"}
      sx={{
        paddingLeft: !mobileViewPort ? "5%" : 0,
        paddingRight: !mobileViewPort ? "5%" : 0,
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      {Object.entries(filters).map(([key, values]) => {
        return (
          <AttributeFilter
            key={key}
            values={values}
            attributeKey={key}
            setSelectedFilter={setSelectedFilter}
          />
        );
      })}
    </Grid>
  );
}

function AttributeFilter({ attributeKey, values, setSelectedFilter }) {
  const { language } = useContext(AppContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const attributeData = ADDITIONAL_FIELDS_ALL.find(
    (a) => a.key === attributeKey
  );

  const fixedLanguge = getFixedLanguageSet(language);
  const label = attributeData?.labelT?.[fixedLanguge] ?? undefined;

  if (!label || !values || values.length <= 1) {
    return null;
  }
  const sortedValues = values.sort((a, b) => {
    if (typeof a === "number" && typeof b === "number") {
      return a - b;
    }
    if (typeof a === "string" && typeof b === "string") {
      return a.localeCompare(b);
    }
    return typeof a === "number" ? -1 : 1;
  });
  return (
    <Grid item xs={5} sm={3} md={3} lg={2}>
      <Box
        onClick={(event) => setAnchorEl(event.currentTarget)}
        sx={{
          maxWidth: "180px",
          margin: "5px",
          borderRadius: "45px",
          backgroundColor: "transparent",
          fontSize: "14px",
          height: "50px",
          display: "flex",
          flexDirection: "row",
          /*       alignItems: "center",
       justifyContent: "center", */
          border: "1px solid lightgrey",
          justifyContent: "space-between",
          overflow: "hidden",
          paddingRight: "10px",
          paddingLeft: "10px",
          transition: "250ms ease-in-out",
          bgcolor: theme.palette.secondary.background,
          "&:hover": {
            bgcolor: "rgba(0,0,0,0.005)",
            boxShadow: theme.shadows[3],
          },
          cursor: "pointer",
        }}
      >
        <Box
          sx={{
            height: "50px",
            transition: "250ms ease-in-out",
            color: theme.palette.primary.main,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "24px",
          }}
        >
          {attributeData?.icon}
        </Box>
        <Box
          sx={{
            height: "50px",
            display: "flex",
            alignItems: "center",
            marginLeft: "5px",
          }}
        >
          <Typography sx={{ color: theme.palette.primary.mainText }}>
            {label}
          </Typography>
        </Box>
        <Box
          sx={{
            height: "50px",
            display: "flex",
            alignItems: "center",
            marginLeft: "5px",
            color: "lightgrey",
          }}
        >
          <ExpandMore />
        </Box>
      </Box>

      <Menu
        id={"menu-" + attributeKey}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          style: {
            marginTop: "5px",
            borderRadius: "15px",
            padding: "10px",
            maxHeight: "25vh",
            border: "1px solid lightgrey",
          },
        }}
      >
        {sortedValues.map((value) => {
          const translatedValue =
            attributeData?.optionsT?.[fixedLanguge]?.[value];

          const valueUnit = attributeData?.unitT?.[fixedLanguge] ?? null;
          return (
            <MenuItem
              key={value}
              onClick={() => {
                setAnchorEl(null);
                setSelectedFilter((prevState) => ({
                  ...prevState,
                  [attributeKey]: value,
                }));
              }}
            >
              <Typography>{translatedValue ?? value}</Typography>
              {valueUnit && (
                <Typography
                  sx={{
                    color: theme.palette.primary.mainText,
                    fontSize: "0.8rem",
                    marginLeft: "5px",
                  }}
                >
                  {valueUnit}
                </Typography>
              )}
            </MenuItem>
          );
        })}
      </Menu>
    </Grid>
  );
}

/* 
   {filter.value.map((option, idx) => {
         if (option === undefined) return;
         const specs = ADDITIONAL_FIELDS_ALL.find(
           (a) => a.key === filter.key
         );
         let alternativeLabel;
         if (specs?.options) {
           alternativeLabel =
             specs?.options.find((o) => o?.value === option)
               ?.label ?? null;
         }

         return (
           <MenuItem
             value={option}
             key={idx + option + Math.random()}
             style={{
               color: theme.palette.primary.mainText,
             }}
             onClick={() => {
               addFilter(filter, option);
               setAnchorEl(null);
             }}
           >
             <Typography variant="body1">
               <OptionValueTranslation
                 option={option}
                 filter={filter}
               />{" "}
               <UnitTranslation filter={filter} />
             </Typography>
           </MenuItem>
         );
       })}
*/
